import { Spinner, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
    loading: {
        height: "100vh",
    }
});

type PageLoadingProp = {
    message: string;
}

function PageLoading(prop: PageLoadingProp) {
    const styles = useStyles();
    return (
        <Spinner
            className={styles.loading}
            appearance="primary" label={prop.message} />
    );

}
export default PageLoading;